import { Ref } from "react";

import { DDQForm, FormConfig } from "../types";
import FormSection, { Mode } from "./FormSection";

export type Props = {
  register?: () => Ref<any>;
  mode: Mode;
  form: DDQForm;
};

export default function DataProtectionFormSection({ register, mode, form }: Props) {
  const formConfig: FormConfig = {
    requiredPII: {
      type: "boolean",
      label: "7A. Is the Entity required by law to safeguard PII?",
    },
    securedPII: {
      type: "boolean",
      label:
        "7B. Does the Entity secure and protect PII, including PII received from other VASPs under the Travel Rule?",
    },
  };

  return (
    <FormSection
      title="Section 7. Data protection"
      formConfig={formConfig}
      register={register}
      mode={mode}
      form={form}
    />
  );
}
